"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.FocusEntity = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../../../types");
var field_groups_1 = require("../../../field-groups");
var fields_1 = require("../../../fields");
var slices_1 = require("../../../slices");
var page_factory_1 = require("./page-factory");
exports.FocusEntity = page_factory_1.pageFactory(types_1.PageType.FOCUS, function (prismicDoc, normalizedPage, logger) {
    var _a, _b;
    return utils_1.compact(__assign(__assign({}, normalizedPage), { subtitle: fields_1.toText((_a = prismicDoc.data) === null || _a === void 0 ? void 0 : _a.subtitle), banner: field_groups_1.toBanner(utils_1.unprefix('header', prismicDoc.data), logger), body: slices_1.toSlices((_b = prismicDoc.data) === null || _b === void 0 ? void 0 : _b.body_slices, logger) }));
});
//# sourceMappingURL=focus.js.map